import { defineComponent as _defineComponent } from 'vue'
import {isMobile} from '../navState';
import { ref, computed, watch } from "vue";
import { useBuilderStore } from "@/store/builder";
import builderCheckList from "./builder-checklist.vue";
import { useBuilderPortalStore } from "@/store/builder-portal";
import { useAuth } from "@/store/auth";
import router from "@/router";
import { useDocumentStore } from "@/store/builderDocuments";
import GiveBuilderAccessModal from "@/components/GiveBuilderAccessModal.vue";
import { FeatureFlags } from "@busy-human/vue-component-library";
import emitter, { EventTypes, events } from '@/events';


export default /*#__PURE__*/_defineComponent({
  __name: 'builder-nav',
  setup(__props, { expose: __expose }) {
  __expose();

const builderStore = useBuilderStore();
const builderPortal = useBuilderPortalStore();
const auth = useAuth();
const builderDocs = useDocumentStore();

const nextDueDate = computed(() => builderPortal.nextDueDate);
const taskOverdue = computed(() => (nextDueDate.value ? nextDueDate.value.valueOf() < (new Date()).valueOf() : false));
const nextDueDateMessage = computed(() => {
	if(!nextDueDate.value) return '';
	const dueDiffSeconds = (nextDueDate.value.valueOf() - (new Date()).valueOf()) / 1000;

	const SECONDS = 60;const HOURS = 60;const DAYS = 24;
	if(Math.round(dueDiffSeconds / (SECONDS * HOURS * DAYS)) === 0){
		return "Next task due today";
	}else{
		return `Next task due in ${Math.round(dueDiffSeconds / (SECONDS * HOURS * DAYS))} days`;
	}
});
const totalProgress = computed(() => builderPortal.checklistProgress);

const showBuilderSelection = ref(false);

const buildersExcludingSelf = computed(() => builderStore.withRecordAsArray.filter(b => b.$id !== builderStore.currentBuilder?.$id));

const showAccessModalFor = ref<string | null>(null);

// function showBuilders(){
// 	console.log("show builders called");
// 	showBuilderSelection.value = !showBuilderSelection.value;
// }

function selectBuilder(builderId: string){
	builderStore.selectBuilder(builderId);
	showBuilderSelection.value = false;
}

async function logout(){
	await auth.signOut();
	await router.push('/shopping-home');
}

function openWelcomeBack(){
    emitter.emit('openWelcomeBack');
}



const __returned__ = { builderStore, builderPortal, auth, builderDocs, nextDueDate, taskOverdue, nextDueDateMessage, totalProgress, showBuilderSelection, buildersExcludingSelf, showAccessModalFor, selectBuilder, logout, openWelcomeBack, get isMobile() { return isMobile }, ref, computed, watch, get useBuilderStore() { return useBuilderStore }, builderCheckList, get useBuilderPortalStore() { return useBuilderPortalStore }, get useAuth() { return useAuth }, get router() { return router }, get useDocumentStore() { return useDocumentStore }, GiveBuilderAccessModal, get FeatureFlags() { return FeatureFlags }, get emitter() { return emitter }, get EventTypes() { return EventTypes }, get events() { return events } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})